import { render } from "./widget-indicator-gas-alarm.vue?vue&type=template&id=224f6d7e&ts=true"
import script from "./widget-indicator-gas-alarm.ts?vue&type=script&lang=ts"
export * from "./widget-indicator-gas-alarm.ts?vue&type=script&lang=ts"

import "./widget-indicator-gas-alarm.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__